export const shouldLoad = () => document.querySelector('[data-controller=video-section]') !== undefined;